const sliderData = [
    {
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,g_faces,h_100,w_100/v1598249693/production/testimonials/user-28_1598249692.jpg",
        name : "Riddhi K Shah",
        twitter : " @Riddhi K Shah ",
        review : "I've had an incredible experience with Milaap as a first-time fund-raiser. They have been patient, competent and efficient. And that led me to leave them a tip-amount that someone else would have had to set up a small fundraiser. I believe in this move and I think it's brilliant."
    },
    {
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,g_faces,h_100,w_100/v1598250884/production/testimonials/user-29_1598250882.jpg",
        name : "Pushpa Aman Singh",
        twitter : " @pushpaaman ",
        review : "The best news for fundraising in India! Will surely promote this in our network. Anoj Viswanathan, what a fabulous Independence Day gift and perfect timing for #GivingTuesdayIndia -#DaanUtsav campaigns!"
    },
    {
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,g_faces,h_100,w_100/v1598247681/production/testimonials/user-26_1598247679.jpg",
        name : "Venkat Krishnan N",
        twitter : " @venkat.n.37 ",
        review : "WHAT A BOLD MOVE!This is such a courageous step taken by Milaap! Really amazing!Great news for all NGOs that are raising money! Congratulations, for this leap of faith! Let's hope it spurs a new breed of fundraisers and helps raise more money for nonprofits across India."
    },
    {
        image : "https://cimages.milaap.org/milaap/image/upload/c_fill,g_faces,h_100,w_100/v1598253112/production/testimonials/user-31_1598253111.jpg",
        name : "Vineet Saraiwala",
        twitter : " @vineet.saraiwala ",
        review : "Absolutely love this leap of faith. When you look at the Milaap platform, it definitely reflects the values of Anoj. This would come as a big boost to the social sector & a very rare instance of generosity which is never easy. Go #Milaap"
    }
]


export const IndexOfSlide = (ind=0)=>{

    return sliderData[ind]

}